module.exports = __webpack_public_path__ + "assets/img/phone.3c5ee83b.png";